import * as React from 'react';
import * as I18n from 'i18n-js';
import { core_apimessages_Money as Money } from '../rql';
import PriceDisplay from './price_display';

interface IProps {
  combinedShippingRate: Money;
}

export default function CombinedShippingPriceCallout(props: IProps) {
  const showFree = props.combinedShippingRate.amountCents === 0;

  return (
    <>
      <PriceDisplay
        amountCents={props.combinedShippingRate.amountCents}
        currency={props.combinedShippingRate.currency}
        display={props.combinedShippingRate.display}
        showFree={showFree}
      />
      {` ${I18n.t('commons.whenYouCombineShipping')}`}
    </>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/combined_shipping_price_callout.tsx